export const SHOW_BOT_LOADING = "SHOW_BOT_LOADING";
export const SHOW_EMOJI_PICKER = "SHOW_EMOJI_PICKER";
export const SHOW_PERSONALIZED_PICKER = "SHOW_PERSONALIZED_PICKER";
export const SHOW_BOT_MENU = "SHOW_BOT_MENU";
export const SET_NODE = "SET_NODE";
export const SET_STORY = "SET_STORY";
export const GET_BOT_FLOW = "GET_BOT_FLOW";
export const SET_BOT_FLOW = "SET_BOT_FLOW";
export const GET_BOT_ACCOUNTS = "GET_BOT_ACCOUNTS";
export const SET_BOT_ACCOUNTS = "SET_BOT_ACCOUNTS";
export const SAVE_BOT_ACCOUNTS = "SAVE_BOT_ACCOUNTS";
export const RESET_BOTFLOW = "RESET_BOTFLOW";
export const GET_BOT_FLOW_TEMPLATES = "GET_BOT_FLOW_TEMPLATES";
export const SET_BOT_FLOW_TEMPLATES = "SET_BOT_FLOW_TEMPLATES";
export const SEND_BOT_FLOW_SKILL = "SEND_BOT_FLOW_SKILL";
export const GET_BOT_INTREGATIONS = "GET_BOT_INTREGATIONS";
export const SAVE_BOT_INTREGATIONS = "SAVE_BOT_INTREGATIONS";
export const GET_DETAILED_BOT_INTREGATIONS = "GET_DETAILED_BOT_INTREGATIONS";
